export enum SoldOutLabel {
	Unavailable = "Unavailable",
	SoldOut = "SoldOut",
	UnavailableOnEshop = "UnavailableOnEshop",
	SoldOutOnEshop = "SoldOutOnEshop",
}
